import { AuthTokens } from "@/model/AuthTokens"
import { Jwt } from "@/model/Jwt"
import { z } from "zod"

export type LoginResponse = {
  accessJwt: Jwt
  refreshJwt: Jwt
}

const mfaChallengeApiDtoSchema = z.object({
  challenge: z.enum(["SMS_MFA", "EMAIL_OTP"]),
  userId: z.string(),
  session: z.string(),
  codeDestination: z.string().nullish(),
})

export type MfaChallengeApiDto = z.infer<typeof mfaChallengeApiDtoSchema>

export type MfaMethod = "SMS_MFA" | "EMAIL_OTP"

export type MfaChallenge = {
  method: MfaMethod
  userId: string
  session: string
  codeDestination: string | null
}

export type LoginResult =
  | { type: "authenticated"; authTokens: AuthTokens }
  | { type: "mfa-challenge"; challenge: MfaChallenge }

export const isMfaChallengeResponse = <T extends object>(
  body: T | MfaChallengeApiDto
): body is MfaChallengeApiDto => "challenge" in body

export const toMfaChallenge = (dto: MfaChallengeApiDto): MfaChallenge => {
  const { challenge, userId, session, codeDestination } =
    mfaChallengeApiDtoSchema.parse(dto)
  return {
    method: challenge,
    userId,
    session,
    codeDestination: codeDestination ?? null,
  }
}
